var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g0, _g1, _g10, _g11, _g12, _g13;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEveningsnacks(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 55.5 55.5",
    style: {
      enableBackground: "new 0 0 55.5 55.5"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#D2D5D7"
    },
    cx: 27.75,
    cy: 27.75,
    r: 27.75
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#FFFFFF"
    },
    cx: 27.75,
    cy: 27.75,
    r: 23.75
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E09A0A"
    },
    d: "M15.663,34.052c0.515-0.018,0.823-0.576,0.549-1.012c-2.9-4.599-5.154-9.575-6.699-14.788 l-0.248-0.838c-0.109-0.366-0.56-0.496-0.847-0.244c-1.855,1.622-2.731,6.241-0.831,10.489 C9.411,31.738,13.199,34.137,15.663,34.052z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E09A0A"
    },
    d: "M37.545,49.505c0.515-0.018,0.823-0.576,0.549-1.012c-2.9-4.599-5.154-9.575-6.699-14.788 l-0.248-0.838c-0.109-0.366-0.56-0.496-0.847-0.244c-1.855,1.622-2.731,6.241-0.831,10.489 C31.294,47.191,35.082,49.591,37.545,49.505z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FAB900"
    },
    d: "M11.625,38.699l-0.781-0.392c-0.341-0.171-0.744,0.069-0.758,0.45 c-0.088,2.463,2.681,6.263,7.078,7.785c4.223,1.462,8.566,0.342,10.19-1.512c0.339-0.388,0.144-0.995-0.362-1.093 C21.653,42.903,16.482,41.14,11.625,38.699z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FAB900"
    },
    d: "M12.811,29.073l-0.584-0.65c-0.255-0.284-0.718-0.207-0.87,0.144 c-0.978,2.262,0.218,6.81,3.759,9.827c3.402,2.898,7.854,3.436,10.041,2.3c0.457-0.238,0.496-0.874,0.06-1.15 C20.621,36.638,16.447,33.115,12.811,29.073z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FDEB08"
    },
    d: "M26.248,40.104c-3.402-2.898-7.854-3.436-10.041-2.3c-0.457,0.237-0.496,0.874-0.06,1.15 c4.596,2.906,8.77,6.429,12.406,10.471l0.584,0.65c0.255,0.284,0.719,0.207,0.87-0.144C30.985,47.669,29.79,43.122,26.248,40.104z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FAB900"
    },
    d: "M20.035,28.217c0.491,0.156,0.969-0.268,0.856-0.77c-1.195-5.304-1.655-10.747-1.368-16.177 l0.046-0.873c0.02-0.381-0.362-0.654-0.717-0.514c-2.291,0.908-4.661,4.969-4.291,9.607C14.917,23.946,17.685,27.474,20.035,28.217 z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FAB900"
    },
    d: "M36.65,29.217c0.491,0.156,0.969-0.268,0.856-0.77c-1.195-5.304-1.655-10.747-1.368-16.177 l0.046-0.873c0.02-0.381-0.362-0.654-0.717-0.514c-2.291,0.908-4.661,4.969-4.291,9.607C31.533,24.946,34.3,28.474,36.65,29.217z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E09A0A"
    },
    d: "M30.829,11.456L30.829,11.456c-1.976,5.065-4.639,9.835-7.914,14.175l-0.526,0.698 c-0.23,0.305-0.066,0.745,0.307,0.827c2.407,0.529,6.643-1.512,8.93-5.564c2.197-3.892,1.876-8.365,0.344-10.296 C31.649,10.892,31.016,10.976,30.829,11.456z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FDEB08"
    },
    d: "M24.977,21.031c1.976-5.065,4.639-9.835,7.914-14.175l0.526-0.698 c0.23-0.305,0.066-0.745-0.307-0.826c-2.407-0.529-6.643,1.512-8.93,5.564c-2.197,3.892-1.876,8.365-0.344,10.296 C24.157,21.595,24.79,21.511,24.977,21.031z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FAB900"
    },
    d: "M29.216,37.232c4.334,1.09,8.563-0.401,10.02-2.389c0.305-0.416,0.057-1.003-0.456-1.057 c-5.407-0.568-10.711-1.875-15.763-3.887l-0.812-0.323c-0.355-0.141-0.736,0.133-0.716,0.514 C21.616,32.551,24.704,36.097,29.216,37.232z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E09A0A"
    },
    d: "M29.947,27.525c-0.375,0.072-0.548,0.508-0.326,0.819c1.432,2.005,5.944,3.33,10.357,1.855 c4.239-1.417,6.998-4.951,7.155-7.411c0.033-0.514-0.493-0.876-0.953-0.645h0c-4.861,2.435-10.034,4.191-15.374,5.217 L29.947,27.525z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E09A0A"
    },
    d: "M10.336,19.947c-0.375,0.072-0.548,0.508-0.326,0.819c1.432,2.005,5.944,3.33,10.357,1.855 c4.239-1.417,6.998-4.951,7.155-7.411c0.033-0.514-0.493-0.876-0.953-0.645h0C21.707,17,16.534,18.756,11.194,19.782L10.336,19.947 z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FAB900"
    },
    d: "M49.036,18.734c-1.432-2.005-5.944-3.33-10.357-1.855c-4.239,1.417-6.998,4.951-7.155,7.411 c-0.033,0.514,0.493,0.876,0.953,0.645c4.861-2.435,10.034-4.191,15.374-5.217l0.858-0.165 C49.084,19.481,49.258,19.044,49.036,18.734z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FDEB08"
    },
    d: "M47.637,36.321c-4.861,2.435-10.034,4.191-15.374,5.217l-0.858,0.165 c-0.375,0.072-0.548,0.508-0.326,0.819c1.432,2.005,5.944,3.33,10.357,1.855c4.239-1.417,6.998-4.951,7.155-7.411 C48.623,36.452,48.098,36.09,47.637,36.321z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FDEB08"
    },
    d: "M48.568,27.321c-4.861,2.435-10.034,4.191-15.374,5.217l-0.858,0.165 c-0.375,0.072-0.548,0.508-0.326,0.819c1.432,2.005,5.944,3.33,10.357,1.855c4.239-1.417,6.998-4.951,7.155-7.411 C49.554,27.452,49.029,27.09,48.568,27.321z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FDEB08"
    },
    d: "M28.568,24.321c-4.861,2.435-10.034,4.191-15.374,5.217l-0.858,0.165 c-0.375,0.072-0.548,0.508-0.326,0.819c1.432,2.005,5.944,3.33,10.357,1.855c4.239-1.417,6.998-4.951,7.155-7.411 C29.554,24.452,29.029,24.09,28.568,24.321z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g0 || (_g0 = /*#__PURE__*/React.createElement("g", null)), _g1 || (_g1 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEveningsnacks);
export default __webpack_public_path__ + "static/media/eveningsnacks.25fe92e1d195dbcda93f6c6337525844.svg";
export { ForwardRef as ReactComponent };